export default [
  {
    path: '/mantenedor/periodicidades',
    name: 'mantenedor-periodicidades',
    component: () => import('@/pages/mantenedor/periodicidades/PeriodicidadesPage.vue'),
    meta: { requiresAuth: true },
  },
];
